import { toFullState } from '@/utilities/address';

export const SUBREGION_IMPORT_REQ_COLUMNS = ['Subregion', 'Zip'];

export const SUBREGION_IMPORT_ATTRIBUTES = {
    name: 'Subregion',
    zip: 'Zip',
    is_direct: 'Direct',
    carrier_id: 'Carrier',
    warehouse_id: 'Warehouse',
    warehouse_carrier_id: 'Warehouse Carrier',
    middle_mile_carrier_id: 'MM Carrier',
    site_code: 'Site Code',
    site_contact_name: 'Site Contact Name',
    site_contact_email: 'Site Contact Email',
    site_contact_phone: 'Site Contact Phone',
};

export const SUBREGION_EXPORT_COLUMNS = [
    {
        header: 'Subregion',
        value: (row) => row.name || '',
    },
    {
        header: 'Zip',
        value: (row) => row.zip || '',
    },
];

const getPrefWarehouse = (id, locations = []) => {
    return locations.reduce((acc, location) => {
        if (id) {
            return location.location_id === id ? location : acc;
        } else {
            return location.preferred_inbound ? location : acc;
        }
    }, locations[0]);
};

export const SUBREGION_AUTO_ASSIGN_EXPORT_COLUMNS = [
    ...SUBREGION_EXPORT_COLUMNS,
    {
        header: 'Direct',
        value: (row) => !!row.is_direct,
    },
    {
        header: 'Carrier',
        value: (row) => row.carrier_id || '',
    },
    {
        header: 'Carrier Name',
        value: (row, data) => {
            const carrier = data?.carriersById?.[row.carrier_id];
            return carrier?.business_name || '';
        },
    },
    {
        header: 'Warehouse Carrier',
        value: (row) => row.warehouse_carrier_id || '',
    },
    {
        header: 'Warehouse Carrier Name',
        value: (row, data) => {
            const carrier = data?.warehouseCarriersById?.[row.warehouse_carrier_id];
            return carrier?.business_name || '';
        },
    },
    {
        header: 'Warehouse',
        value: (row) => row.warehouse_id || '',
    },
    {
        header: 'Warehouse Address 1',
        value: (row, data) => {
            const locations = data?.carriersById?.[row.carrier_id]?.locations || [];
            return getPrefWarehouse(row.warehouse_id, locations)?.business_address || '';
        },
    },
    {
        header: 'Warehouse Address 2',
        value: (row, data) => {
            const locations = data?.carriersById?.[row.carrier_id]?.locations || [];
            return getPrefWarehouse(row.warehouse_id, locations)?.business_unit || '';
        },
    },
    {
        header: 'Warehouse City',
        value: (row, data) => {
            const locations = data?.carriersById?.[row.carrier_id]?.locations || [];
            return getPrefWarehouse(row.warehouse_id, locations)?.business_city || '';
        },
    },
    {
        header: 'Warehouse State',
        value: (row, data) => {
            const locations = data?.carriersById?.[row.carrier_id]?.locations || [];
            return toFullState(getPrefWarehouse(row.warehouse_id, locations)?.business_state);
        },
    },
    {
        header: 'Warehouse Zip',
        value: (row, data) => {
            const locations = data?.carriersById?.[row.carrier_id]?.locations || [];
            return getPrefWarehouse(row.warehouse_id, locations)?.business_zip || '';
        },
    },
    {
        header: 'MM Carrier',
        value: (row) => row.middle_mile_carrier_id || '',
    },
    {
        header: 'MM Carrier Name',
        value: (row, data) => {
            const carrier = data?.mmCarriersById?.[row.middle_mile_carrier_id];
            return carrier?.business_name || '';
        },
    },
    {
        header: 'Site Code',
        value: (row) => row.site_code || '',
    },
    {
        header: 'Site Contact Name',
        value: (row) => row.site_contact_name || '',
    },
    {
        header: 'Site Contact Email',
        value: (row) => row.site_contact_email || '',
    },
    {
        header: 'Site Contact Phone',
        value: (row) => row.site_contact_phone || '',
    },
];
